import { AlarmTypes, AlarmLevels } from 'sigma-mappings';

export default {
  gases: [
    {
      gas: 'H₂',
    },
    {
      gas: 'CH₄',
    },
    {
      gas: 'C₂H₆',
    },
    {
      gas: 'C₂H₄',
    },
    {
      gas: 'C₂H₂',
    },
    {
      gas: 'CO',
    },
    {
      gas: 'CO₂',
    },
    {
      gas: 'O₂',
    },
    {
      gas: 'N₂',
    },
  ],
  header: [
    {
      name: 'engineering.chromatography.alarm-levels-parameters.high-gas-value',
      alarmLevel: AlarmLevels.HIGH,
      alarmTypeChromatography: AlarmTypes.CONCENTRATION,
    },
    {
      name: 'engineering.chromatography.alarm-levels-parameters.very-high-gas-value',
      alarmLevel: AlarmLevels.VERY_HIGH,
      alarmTypeChromatography: AlarmTypes.CONCENTRATION,
    },
    {
      name: 'engineering.chromatography.alarm-levels-parameters.high-rate-value',
      alarmLevel: AlarmLevels.HIGH,
      alarmTypeChromatography: AlarmTypes.RATE,
    },
    {
      name: 'engineering.chromatography.alarm-levels-parameters.very-high-rate-value',
      alarmLevel: AlarmLevels.VERY_HIGH,
      alarmTypeChromatography: AlarmTypes.RATE,
    },
  ],
  response: [],
};
